<template>
  <div class="dialog-container" v-loading="isLoading">
    <el-alert class="mb-3" :title="errorMessage" type="error" show-icon v-if="errorMessage"></el-alert>
    <el-transfer class="office-transfer-panel mb-3" v-model="selectedOffices" :props="{
      key: 'id',
      label: 'name'
    }" :titles="['Available', 'Selected']" :data="allOfficesFormatted">
    </el-transfer>
    <el-row :gutter="18" class="dialog-footer">
      <el-col :span="24" class="align-right">
        <el-button @click="closeDialog">Cancel</el-button>
        <el-button type="primary" @click="updateAllowedOffices">Update Allowed Offices</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import map from 'lodash/map';
import get from 'lodash/get';
import OfficeToRefType from '@/util/OfficeToRefType';
import api from '@/api';

export default {
  name: 'UserAllowedOfficesEditor',
  props: {
    user: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      isLoading: false,
      selectedOffices: [],
      errorMessage: '',
    };
  },
  methods: {
    ...mapActions('Lookup', ['getOffices']),
    updateAllowedOffices() {
      this.errorMessage = '';
      this.isLoading = true;
      api.user.updateAllowedOffices(this.user, this.selectedOffices).then((response) => {
        this.$notify.success({
          title: 'Success',
          message: 'The user\'s office associations have been updated.',
          position: 'bottom-right',
        });
        this.$emit('userUpdated', response.data);
        this.closeDialog();
      }).catch((e) => {
        this.errorMessage = get(e, 'response.data', 'An error occurred. Please try again.');
      }).finally(() => {
        this.isLoading = false;
      });
    },
    closeDialog() {
      this.isLoading = false;
      this.errorMessage = '';
      this.setUsersSelectedOffices();
      this.$emit('close');
    },
    setUsersSelectedOffices() {
      this.selectedOffices = this.user.allowedOffices;
    },
  },
  computed: {
    ...mapGetters('Lookup', [
      'allOffices',
      'officeMap',
    ]),
    allOfficesFormatted() {
      return map(this.allOffices, office => OfficeToRefType(office));
    },
  },
  watch: {
    user() {
      this.setUsersSelectedOffices();
    },
  },
  mounted() {
    this.setUsersSelectedOffices();
  },
};

</script>

<style lang="scss">
.office-transfer-panel {
  .el-transfer-panel {
    width: 300px;

    .el-transfer-panel__body {
      height: 400px;

      .el-transfer-panel__list {
        height: 100%;
      }
    }
  }
}
</style>
